import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import {useMediaQuery} from "react-responsive";
import classnames from "classnames";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Typography from "@mui/material/Typography";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import {useDealContext} from "../../contexts/DealContext";
import {PopoverInput} from "../../components/PopoverInput";
import EditLocationAltOutlinedIcon from '@mui/icons-material/EditLocationAltOutlined';
import Tooltip from "@mui/material/Tooltip";
import {LocationModal} from "./LocationModal";
import {useModalsStore} from "../../stores/modalsStore";
import {useShallow} from "zustand/react/shallow";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";

export const DealPageInfo = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { updateDealResponse, dealState, setDealStateWithoutQuoteUpdate, setDealStateWithUpdate, dealColorLight } = useDealContext()

    const [notes, setNotes] = useState('')
    const [acv, setAcv] = useState('')
    const [payoff, setPayoff] = useState('')
    const [profit, setProfit] = useState('')
    const [demoMiles, setDemoMiles] = useState('')

    const {
        openModal,
        closeModalById,
    } = useModalsStore(
        useShallow((state) => ({
            openModal: state.openModal,
            closeModalById: state.closeModalById,
        }))
    )

    const saveDealLocation = (location, shouldSetCustomerLocation, shouldSetDealerLocation) => {
        closeModalById("LocationModal")
        const formatted_quote = structuredClone(dealState).formatted_quote
        if (location.state !== dealState.state) {
            formatted_quote.fees = []
            formatted_quote.rebates = []
        }

        let updateObj = {}

        if (shouldSetCustomerLocation) {
            updateObj = {
                address_line_one: location.address_line_one,
                address_line_two: location.address_line_two,
                city: location.city,
                state: location.state,
                zipcode: location.zipcode,
                county: location.county,
                formatted_quote: formatted_quote
            }
        }
        if (shouldSetDealerLocation) {
            updateObj = {
                ...updateObj,
                dealer_location: location,
                dealer_location_id: location.id,
                dealer_address_line_one: location.address_line_one,
                dealer_address_line_two: location.address_line_two,
                dealer_city: location.city,
                dealer_state: location.state,
                dealer_zipcode: location.zipcode,
                dealer_county: location.county
            }
        }
        if (!_.isEmpty(updateObj)) {
            setDealStateWithUpdate(updateObj, true)
        }
    }

    const car = dealState.car_detail
    const isLoading = updateDealResponse?.loading
    const isPurchase = dealState.is_purchase

    return (
        <React.Fragment>
            {/* Wrapper that occupies grid cell (col 1, row 1) and contains Vehicle and Location panels */}
            <div className="panel-vehicle-location-stack vehicle-stack">
                <Box className="DealPageInfo_box panel-vehicle">
                    <div className="panel-header">
                        <div className="panel-title">
                            {car.year} {car.make} {car.model}{car.is_new ? "" : " [Used]"}
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className="vehicle-trim">
                            {car.trim}{car.manufacture_code ? ` [${car.manufacture_code}]` : ''}
                        </div>
                        <div className="vehicle-vin">
                            Vin: {dealState.vin || '—'}
                        </div>
                        <div className="demo-miles-row">
                            <label>Demo Miles:</label>
                            <input
                                type="number"
                                placeholder="0"
                                className="demo-miles-input"
                                value={demoMiles}
                                onChange={(e) => setDemoMiles(e.target.value)}
                            />
                        </div>
                        {
                            Boolean(dealState?.car_detail.option_codes.length) && (
                                <div className="vehicle-options">
                                    <span>Options: </span>
                                    <Select
                                        onClose={(e) => {
                                            setTimeout(() => {
                                                if (document.activeElement) {
                                                    document.activeElement.blur();
                                                }
                                                document.body.focus();
                                                document.body.blur();
                                            }, 0);
                                        }}
                                        className="DealPageInfo_select-input"
                                        multiple={true}
                                        value={dealState?.option_code_ids}
                                        disabled={dealState?.loading}
                                        onChange={(e) => {
                                            const option_code_ids = e.target.value
                                            setDealStateWithUpdate({ option_code_ids: option_code_ids })
                                        }}
                                    >
                                        {
                                            dealState?.car_detail.option_codes?.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </div>
                            )
                        }
                    </div>
                </Box>

                <Box className={classnames('DealPageInfo_box panel-location', { isPurchase })}>
                    <div className="panel-header">
                        <div className="panel-title">Location</div>
                        <Tooltip title="Edit Location" arrow placement="top">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 16, height: 16, color: '#4A90E2'}} className="action-icon EditLocationIcon" onClick={() => {
                                openModal({
                                    element: LocationModal,
                                    id: "LocationModal",
                                    props: {
                                        selectLocation: saveDealLocation,
                                        isSaving: updateDealResponse?.loading,
                                    }
                                })
                            }}>
                                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
                                <circle cx="12" cy="10" r="3"/>
                            </svg>
                        </Tooltip>
                    </div>
                    <div className="panel-body">
                        <div className="location-row">
                            <span className="location-key">Customer:</span>
                            <span className="location-val">{ dealState.county }, { dealState.state }, { dealState.zipcode }</span>
                        </div>
                        <div className="location-row">
                            <span className="location-key">Dealer:</span>
                            <span className="location-val">{ dealState.dealer_county }, { dealState.dealer_state }, { dealState.dealer_zipcode }</span>
                        </div>
                    </div>
                </Box>
            </div>

            <Box className="DealPageInfo_box panel-notes">
                <div className="panel-header">
                    <div className="panel-title">Notes</div>
                </div>
                <div className="panel-body">
                    <textarea
                        className="description-input notes-textarea"
                        placeholder="Add a note for this deal..."
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                </div>
            </Box>

            <Box className="DealPageInfo_box panel-tradein dealPagePayment-column">
                <div className="panel-header">
                    <div className="panel-title">Trade In</div>
                </div>
                <div className="panel-body">
                    <div className="payment-row">
                        <span className="payment-row_name">ACV:</span>
                        <CustomCurrencyInput
                            className="payment-row_value"
                            value={acv}
                            onChange={(value) => setAcv(value)}
                        />
                    </div>
                    <div className="payment-row">
                        <span className="payment-row_name">Payoff:</span>
                        <CustomCurrencyInput
                            className="payment-row_value"
                            value={payoff}
                            onChange={(value) => setPayoff(value)}
                        />
                    </div>
                    <div className="payment-row">
                        <span className="payment-row_name">Profit:</span>
                        <CustomCurrencyInput
                            className="payment-row_value"
                            value={profit}
                            onChange={(value) => setProfit(value)}
                        />
                    </div>
                </div>
            </Box>
        </React.Fragment>
    )
}
